import React from 'react';
import { Copy, Stack, SvgEnvelope } from '@grubhubprod/gh-cookbook-react';
import { DataTable } from 'src/components/DataTable';
import { Tooltip } from 'src/components/Tooltip/Tooltip';
import { useSendEmployeeWelcomeEmail } from 'src/components/enterprise/features/Employee/EmployeeListPage/hooks/useSendEmployeeWelcomeEmail';

export interface EmployeeListTableWelcomeEmailButtonProps {
  corpId: string;
  dinerId: string;
  isSent: boolean;
  onSent: (dinerId: string) => void;
}

export function EmployeeListTableWelcomeEmailButton({
  corpId,
  dinerId,
  isSent,
  onSent,
}: EmployeeListTableWelcomeEmailButtonProps): JSX.Element {
  const { sendWelcomeEmail, isLoading } = useSendEmployeeWelcomeEmail({
    corpId,
    dinerId,
    onSent,
  });
  const label = isSent ? 'Email Sent' : 'Send Welcome Email';
  const disabled = isSent || isLoading;

  return (
    <Tooltip
      roundedContainer
      content={
        <Copy variant="body" color="invertedPrimaryText">
          {label}
        </Copy>
      }
    >
      <Stack>
        <DataTable.Button
          variant="tertiary"
          onClick={sendWelcomeEmail}
          disabled={disabled}
          isLoading={isLoading}
        >
          <SvgEnvelope size="24px" aria-label={label} />
        </DataTable.Button>
      </Stack>
    </Tooltip>
  );
}
